/**
 * Animates the owl logo with floating and glowing effects
 * @param {HTMLElement} owlElement - The owl logo DOM element
 */
export const animateOwl = (owlElement) => {
    if (!owlElement) return;

    // Float animation parameters
    let floatY = 0;
    let floatDirection = 1;
    const floatSpeed = 0.3;
    const floatMax = 15;

    // Rotation animation parameters
    let rotation = 0;
    let rotationDirection = 1;
    const rotationSpeed = 0.1;
    const rotationMax = 5;

    // Glow animation parameters
    let glowIntensity = 0;
    let glowDirection = 1;
    const glowSpeed = 0.5;
    const glowMin = 0;
    const glowMax = 15;

    // Animation loop
    const animate = () => {
        // Update float position
        if (Math.abs(floatY) >= floatMax) {
            floatDirection *= -1;
        }
        floatY += floatSpeed * floatDirection;

        // Update rotation
        if (Math.abs(rotation) >= rotationMax) {
            rotationDirection *= -1;
        }
        rotation += rotationSpeed * rotationDirection;

        // Update glow
        if (glowIntensity >= glowMax || glowIntensity <= glowMin) {
            glowDirection *= -1;
        }
        glowIntensity += glowSpeed * glowDirection;

        // Apply transformations
        owlElement.style.transform = `translateY(${floatY}px) rotate(${rotation}deg)`;
        owlElement.style.filter = `drop-shadow(0 0 ${glowIntensity}px rgba(200, 163, 95, 0.7))`;

        requestAnimationFrame(animate);
    };

    // Start animation
    animate();
};

/**
 * Animates the eyes of the owl logo to follow the mouse cursor
 * @param {HTMLElement} owlElement - The owl logo DOM element
 * @param {HTMLElement} leftEyeElement - The left eye DOM element
 * @param {HTMLElement} rightEyeElement - The right eye DOM element
 */
export const animateEyes = (owlElement, leftEyeElement, rightEyeElement) => {
    if (!owlElement || !leftEyeElement || !rightEyeElement) return;

    const maxEyeMovement = 3; // Maximum movement in pixels

    document.addEventListener('mousemove', (e) => {
        const owlRect = owlElement.getBoundingClientRect();
        const owlCenterX = owlRect.left + owlRect.width / 2;
        const owlCenterY = owlRect.top + owlRect.height / 2;

        // Calculate direction from owl center to mouse position
        const deltaX = e.clientX - owlCenterX;
        const deltaY = e.clientY - owlCenterY;

        // Normalize and limit the movement
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const normalizedX = deltaX / distance * maxEyeMovement;
        const normalizedY = deltaY / distance * maxEyeMovement;

        // Apply the eye movement
        leftEyeElement.style.transform = `translate(${normalizedX}px, ${normalizedY}px)`;
        rightEyeElement.style.transform = `translate(${normalizedX}px, ${normalizedY}px)`;
    });
};